import axios from 'axios';
import C  from './apiconstants';

export const callGet = (apiUrl) => {
    let axiosConfig = getHeader();
    return axios
      .get(apiUrl, axiosConfig)
      .then((response) => {
          return response;
      })
      .catch((err) => {
        return {
            json: {},
            status: C.API_ERROR,
            error: {
                errorCode: "0001",
                description: "Error calling GET API: " + apiUrl,
                message: err.message,
                timestamp: new Date(),
                stack: err.stack
            }
        };
      });
};

export const callPost = (apiUrl, request) => {
    let axiosConfig = getHeader();
    return axios
      .post(apiUrl, request)
      .then((response) => {
          return response;
      })
      .catch((err) => {
        return {
            json: {},
            status: C.API_ERROR,
            error: {
                errorCode: "0002",
                description: "Error calling POST API: " + apiUrl,
                message: err.message,
                timestamp: new Date(),
                stack: err.stack
            }
        };
      });
};

  let getHeader = function() {
      return {
          headers : {
          }
      }
  }
/*let getHeader = function() {
    return {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
        }
    };
}
*/